import { render, staticRenderFns } from "./production-info-edit-tab.vue?vue&type=template&id=4e2aafb7&scoped=true"
import script from "./production-info-edit-tab.vue?vue&type=script&lang=js"
export * from "./production-info-edit-tab.vue?vue&type=script&lang=js"
import style0 from "./production-info-edit-tab.vue?vue&type=style&index=0&id=4e2aafb7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2aafb7",
  null
  
)

export default component.exports